import React from "react";
import styles from "./TrustBar.module.css";

const HIGHLIGHTS = [
  {
    icon: "🏠",
    title: "Homes, Offices & Shops",
    desc: "No property is too big or too small.",
  },
  {
    icon: "🧰",
    title: "Cleaning + Renovation",
    desc: "One team you can call for both.",
  },
  {
    icon: "📅",
    title: "Flexible Scheduling",
    desc: "Book a time slot that works for you.",
  },
  {
    icon: "💬",
    title: "Fast WhatsApp Replies",
    desc: "Get a free quote in minutes.",
  },
];

export default function TrustBar() {
  return (
    <section className={styles.bar}>
      <div className={`container ${styles.grid}`}>
        {HIGHLIGHTS.map((item) => (
          <div className={styles.item} key={item.title}>
            <span className={styles.icon} aria-hidden="true">
              {item.icon}
            </span>
            <div>
              <p className={styles.itemTitle}>{item.title}</p>
              <p className={styles.itemDesc}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
